import { Col, Row } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import WelcomeTextContainer from "./chat.welcomeText";
import ChatList from "./chat.list";
import { Content } from "antd/es/layout/layout";
import ChatTextArea from "./chat.textarea";
import ChatHeaderConversation from "./chat.header.conversation";
import ChatSideBar from "./chat.sidebar";
import ChatHeaderParticipant from "./chat.header.participant";
import { useMemo } from "react";
import { groupMessagesForDisplay } from "../../../store/slices/messages.slice";
import ChatCard from "./chat.card";

const rowStyle: React.CSSProperties = {
  height: "100%",
  background: "rgb(245, 246, 247)",
  position: "relative",
};

const MessageContainerStyle: React.CSSProperties = {
  //   background: "white",
  height: "100%",
};

const MessageSidebarSyle: React.CSSProperties = {
  width: "100px",
  background: "white",
};


const ChatContainer = ({
  ffmpegRef,
  isNewConversation,
  sendMessage,
  setIsNewConversation,
  deleteMessage,
  participants,
  setParticipants,
}: {
  isNewConversation: boolean;
  sendMessage: Function;
  setIsNewConversation: Function
  ffmpegRef: any;
  deleteMessage: Function,
  participants: string[];
  setParticipants: Function;
}) => {
  const { selectedConversation } = useSelector(
    (state: RootState) => state.conversation
  );
  const { messages: offlineMessages } = useSelector(
    (state: RootState) => state.offlineMessages
  );
  const { data: messageData } = useSelector((state: RootState) => state.messages);
  const { selectedDid } = useSelector((state: RootState) => state.smsDids);
  const draftMessages = useMemo(() => {
    const expected = [...participants].sort().join("|");
    return groupMessagesForDisplay(
      [
        ...offlineMessages,
        ...messageData
          .filter((item) => !item.conversation_id)
          .flatMap((item) => item.messages),
      ].filter(
        (message) =>
          !message.conversation_id &&
          message.did === selectedDid &&
          [...(message.conversation_participants || [message.participant])]
            .sort()
            .join("|") === expected
      )
    );
  }, [offlineMessages, messageData, participants, selectedDid]);

  return (
    <Content style={{ height: "100%" }}>
      <Row style={rowStyle}>
        <Col flex="auto" style={MessageContainerStyle}>
          {selectedConversation && !isNewConversation && (
            <ChatHeaderConversation selectedConversation={selectedConversation} />
          )}
          {isNewConversation && (
            <ChatHeaderParticipant
              participants={participants}
              setParticipants={setParticipants}
              isEnabled={draftMessages.length === 0}
              setIsNewConversation={setIsNewConversation}
            />
          )}
          {!selectedConversation && !isNewConversation && (
            <WelcomeTextContainer />
          )}
          {isNewConversation && draftMessages.length > 0 && (
            <div style={{ height: "calc(100% - 220px)", overflow: "auto", padding: 10 }}>
              {draftMessages.map((message) => (
                <ChatCard
                  key={message.clientId || message.id}
                  ffmpegRef={ffmpegRef}
                  message={message}
                  deleteMessage={deleteMessage}
                  sendMessage={sendMessage}
                />
              ))}
            </div>
          )}
          {selectedConversation && !isNewConversation && (
            <ChatList key={`chat-${selectedConversation.conversation_id}`} sendMessage={sendMessage} deleteMessage={deleteMessage} ffmpegRef={ffmpegRef} conversation={selectedConversation} />
          )}
          {(selectedConversation || isNewConversation) && <ChatTextArea  setIsNewConversation={setIsNewConversation} participants={participants} setParticipants={setParticipants} sendMessage={sendMessage} />}
        </Col>
        {selectedConversation && (
          <Col flex="100px" style={MessageSidebarSyle}>
            <ChatSideBar selectedConversation={selectedConversation}/>
          </Col>
        )}
      </Row>
    </Content>
  );
};

export default ChatContainer;
